// extracted by mini-css-extract-plugin
module.exports = {"claimFaq":"ClaimFAQ_claimFaq_34v0I","claimTitle":"ClaimFAQ_claimTitle_pRxwx","sections":"ClaimFAQ_sections_pW-zl"};